// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductCateItem_wrapper__l9nMm","icon":"ProductCateItem_icon__EUIMD","label":"ProductCateItem_label__bJrdx"};